import { useQuery } from "@tanstack/react-query";
import { CertificateRepositoryImpl } from "../../data/repository/certificate_repository_impl";
import { CertificateInterface } from "../interface/certificate_interface";

export const useGetCertificate = (themeId?: string) => {
  const repository = new CertificateRepositoryImpl();

  return useQuery<CertificateInterface>({
    queryFn: () => repository.getCertificateByThemeId(themeId!),
    queryKey: ["certificate", themeId],
    enabled: !!themeId,
    staleTime: Infinity,
  });
};
